// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__LSA3P","card":"Loader_card__iWAtp"};